/**
 * Organisation-context store — which org is the user currently acting as?
 *
 * Phase 1a is UI-only: selecting an org doesn't yet change what projects,
 * chats, or data the user sees (that's Phase 2's access-control migration).
 * The store tracks the selection and persists it to localStorage so a
 * refresh keeps the same context.
 *
 * Value "null" means Personal (the user's own scope). Value "<org_id>"
 * means "acting as a member of this org".
 */
import { create } from "zustand";
import { persist } from "zustand/middleware";

interface OrgState {
  /** Currently-selected org id. null = Personal context. */
  activeOrgId: string | null;
}

interface OrgActions {
  setActiveOrg: (orgId: string | null) => void;
}

const STORAGE_KEY = "cf.activeOrg";

export const useOrgStore = create<OrgState & OrgActions>()(
  persist(
    (set) => ({
      activeOrgId: null,
      setActiveOrg: (orgId) => set({ activeOrgId: orgId }),
    }),
    { name: STORAGE_KEY },
  ),
);
